<template>
  <div class="dashboard-home">
    <div class="dashboard-filters">
      <label>
        Inicio:
        <input
          v-model="startDate"
          type="date"
          @change="fetchDashboardData"
        >
      </label>
      <label>
        Fin:
        <input
          v-model="endDate"
          type="date"
          @change="fetchDashboardData"
        >
      </label>
    </div>
    <DashboardCards
      :quote-states="quoteStates"
      :order-states="orderStates"
      :lost-sales="lostSalesSummary"
      :loading="loading"
    />
    <DashboardBarChart
      :sales-data="salesData"
      :loading="loading"
    />
  </div>
</template>

<script>
import axios from '@/libs/axios'
import DashboardCards from './dashboard/DashboardCards.vue'
import DashboardBarChart from './dashboard/DashboardBarChart.vue'

function formatDate(date) {
  if (!date) return ''
  const d = new Date(date)
  return d.toISOString().slice(0, 10)
}

export default {
  name: 'Home',
  components: {
    DashboardCards,
    DashboardBarChart,
  },
  data() {
    const today = new Date()
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1)
    return {
      quoteStates: [],
      orderStates: [],
      salesData: [],
      lostSalesSummary: null,
      startDate: formatDate(firstDay),
      endDate: formatDate(today),
      loading: false,
    }
  },
  mounted() {
    this.fetchDashboardData()
  },
  methods: {
    async fetchDashboardData() {
      this.loading = true
      try {
        const params = {}
        if (this.startDate) params.start = this.startDate
        if (this.endDate) params.end = this.endDate
        const [quotesRes, ordersRes, salesRes, lostSalesRes] = await Promise.all([
          axios.get('/dashboard/quotes-by-status', { params }),
          axios.get('/dashboard/orders-by-status', { params }),
          axios.get('/dashboard/sales-vs-target', { params }),
          axios.get('/dashboard/lost-sales-summary', { params }),
        ])
        this.quoteStates = quotesRes.data
        this.orderStates = ordersRes.data
        this.salesData = salesRes.data
        this.lostSalesSummary = lostSalesRes.data
      } catch (e) {
        this.quoteStates = []
        this.orderStates = []
        this.salesData = []
        this.lostSalesSummary = null
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.dashboard-home {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  padding: 2rem 0.5rem 1.5rem 0.5rem;
  max-width: 90%;
  margin: 0 auto;
}
.dashboard-filters {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}
.dashboard-filters label {
  font-weight: 500;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
}
.dashboard-filters input[type="date"] {
  margin-top: 0.2rem;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  border: 1px solid #bdbdbd;
  font-size: 1rem;
}
</style>
